(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountClientLoyaltyProgram',
	};

	var $form,
	    _resetVendor,
	    _selectVendor;


	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		Adzuki.Typeahead(
			'#mytripsaccountclientloyaltyprogram-vendor_search',
			'/Vendors/search',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				_selectVendor(item);
			}
		);

		$('#reset-vendor').click(function resetClicked() {
			$('#mytripsaccountclientloyaltyprogram-name').val('');
			$('#mytripsaccountclientloyaltyprogram-vendor_id').val('');
			$('#mytripsaccountclientloyaltyprogram-cruise_line_id').val('');
		});

		// Vendor select logic
		$('#mytripsaccountclientloyaltyprogram-vendor_select').on('change', function change(e) {
			var vendor_id = $(e.target).val();

			$('#mytripsaccountclientloyaltyprogram-vendor_id').val(vendor_id);

			Adzuki.Ajax.get('/Vendors/getVendor/' + vendor_id).then(function success(vendor) {
				_selectVendor(vendor);
			});
		});

		// Reset vendor information when vendor typeahead is reset
		$('#mytripsaccountclientloyaltyprogram-vendor_search').on('ta.reset', function reset(e) {
			_resetVendor();
		});

		// Toggle vendor search and select
		$form.find('.select-vendor').on('click', function click(e) {
			e.preventDefault();

			$form.find('.vendor-search .reset-typeahead a').trigger('click');

			$form.find('.vendor-search').addClass('hidden');
			$form.find('.vendor-select').removeClass('hidden');
		});

		$form.find('.search-vendor').on('click', function click(e) {
			e.preventDefault();

			$form.find('.vendor-search .reset-typeahead a').trigger('click');

			$form.find('.vendor-search').removeClass('hidden');
			$form.find('.vendor-select').addClass('hidden');

			$('#mytripsaccountclientloyaltyprogram-vendor_select').val('');
		});
	};

	_resetVendor = function _resetVendor()
	{
		$form.find('.vendor-details').addClass('hidden');
	};

	_selectVendor = function _selectVendor(vendor)
	{
		_resetVendor();

		$('#mytripsaccountclientloyaltyprogram-vendor_id').val(vendor.id);

		if (vendor.primary_component_type === 'cruise') {
			$('#mytripsaccountclientloyaltyprogram-cruise_line_id').val(vendor.primary_component_existing_vendor_id);

			Adzuki.Ajax.get('/MyTrips/getLoyaltyProgramNameByVendorId/' + vendor.id).then(function success(program) {
				$('#mytripsaccountclientloyaltyprogram-name').val(program.program);
			});
		}

		$form.find('.vendor-details').removeClass('hidden');

	};

}(jQuery, window.Adzuki || {}));